import * as React from "react";
import { BackButtonHeader } from "@/components/vroom/back-button-header";

export interface DetailScreenLayoutProps {
  title: string;
  onBack: () => void;
  rightSlot?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export function DetailScreenLayout({
  title,
  onBack,
  rightSlot,
  footer,
  children,
}: DetailScreenLayoutProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-surface text-ink-900">
      <BackButtonHeader title={title} onBack={onBack} rightSlot={rightSlot} />
      <main className="flex-1 px-4 py-4">{children}</main>
      {footer ? (
        <footer className="flex items-center justify-end gap-2 border-t border-line bg-surface px-4 py-3">
          {footer}
        </footer>
      ) : null}
    </div>
  );
}
